export const currentLanguage = () => document.documentElement.lang;
